import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { Button, ButtonSize, ButtonTheme } from '../common/Button';
import { useTranslation } from 'react-i18next';

type Props = {
    readonly currentRefine?: string;
    readonly refinedSearchCategories?: { [key: string]: string };
    readonly onUnsetRefineSearch: () => void;
    readonly onRefineSearch: (refine: string) => void;
};

export const RefineSearchButtons = ({
    refinedSearchCategories: categories,
    onRefineSearch,
    onUnsetRefineSearch,
    currentRefine: activeRefinement
}: Props) => {
    const { t } = useTranslation();

    if (isEmpty(categories)) {
        return null;
    }

    return (
        <div className="refine-search-btns" data-displayname="RefineSearchButtons">
            <h4>{t('components.searchResults.refine')}</h4>
            {categories && !isEmpty(categories)
                ? Object.keys(categories).map(key => {
                      const isActiveRefinement = activeRefinement === key;
                      return (
                          <Button
                              className={isActiveRefinement ? 'active-refined' : undefined}
                              text={t(`components.searchResults.refinedSearchCategories.${key}`, {
                                  defaultValue: categories[key]
                              })}
                              key={key}
                              onClick={isActiveRefinement ? onUnsetRefineSearch : () => onRefineSearch(key)}
                              size={ButtonSize.SMALL}
                              theme={isActiveRefinement ? ButtonTheme.POSITIVE_INVERT : ButtonTheme.NEUTRAL}
                          />
                      );
                  })
                : null}
        </div>
    );
};
